import { trackQualifiedListen } from '~/productAnalytics';

/** One qualified listen per mounted episode, after 30 seconds of actual playback. */
export default class TrackListening {
    private elapsed = 0;
    private startedAt: number | null = null;
    private timer: ReturnType<typeof setTimeout> | undefined;
    private tracked = false;

    start(): void {
        if (this.startedAt !== null || this.tracked) return;
        this.startedAt = performance.now();
        this.timer = setTimeout(
            () => {
                this.tracked = true;
                this.pause();
                void trackQualifiedListen();
            },
            Math.max(0, 30_000 - this.elapsed),
        );
    }

    pause(): void {
        if (this.startedAt !== null) {
            this.elapsed += performance.now() - this.startedAt;
            this.startedAt = null;
        }
        clearTimeout(this.timer);
        this.timer = undefined;
    }

    destroy(): void {
        this.pause();
    }
}
